export default {
  setIdioma({ commit }, payload) {
    localStorage.setItem('idioma', payload);
    commit('SET_IDIOMA', payload);
  },
};
